import { MESSAGES_PER_REQUEST } from '../constants/signalMessages';
import { FilterState } from '../contexts/filtersContext';
import { mapSignalsMessages } from '../mappers/signalMessages';
import { EditorialCategoryType } from '../models/enums';
import {
	Message,
	MessageNewerPayload,
	MessageResponse
} from '../models/signalMessages';

const fetcher = async (
	user,
	latestReadMessage: string,
	offset: number,
	filters?: FilterState
): Promise<MessageNewerPayload> => {
	const apiEndpointUrl = `${process.env.REACT_APP_GATEWAY_URL}${window.config.Endpoints.SignalMessages}`;
	try {
		let resourceUrl = `limit=${MESSAGES_PER_REQUEST}&offset=${offset}`;

		if (latestReadMessage)
			resourceUrl += `&dateTime=${
				new Date(latestReadMessage) > new Date()
					? new Date().toISOString()
					: latestReadMessage
			}`;
		if (filters.categories.includes(EditorialCategoryType.Trade)) {
			resourceUrl += '&categories=trade';
		} else {
			filters.categories.map((filter) => (resourceUrl += `&categories=${filter}`));
		}
		if (filters.markets.length > 0)
			filters.markets.map((filter) => (resourceUrl += `&markets=${filter}`));
		if (filters.tags.length > 0)
			filters.tags.map((filter) => (resourceUrl += `&tags=${filter}`));

		const response = await fetch(`${apiEndpointUrl}?${resourceUrl}`, {
			method: 'GET',
			headers: {
				Accept: 'application/json',
				Authorization: `bearer ${user?.token}`
			}
		});

		if (response.ok) {
			const mappedMessages = (await response.json())?.map(
				(x: MessageResponse) => mapSignalsMessages(x, true)
			) as Message[];

			const nextOffset = offset - MESSAGES_PER_REQUEST;
			const noMore = mappedMessages.length < MESSAGES_PER_REQUEST;

			return {
				data: mappedMessages,
				nextOffset,
				noMore
			} as MessageNewerPayload;
		}
		return { noMore: response.status === 404 } as MessageNewerPayload;
	} catch (error) {
		console.log(error);
		return { noMore: false } as MessageNewerPayload;
	}
};

export async function loadNewerMessages(
	user,
	latestReadMessage: string,
	offset: number,
	filters?: FilterState
): Promise<MessageNewerPayload> {
	return fetcher(user, latestReadMessage, offset, filters);
}
